import axios from "axios";
import store from "@/store";

const API = axios.create({
  baseURL: process.env.VUE_APP_WEB_API_URL,
  withCredentials: true,
});

API.interceptors.request.use(function(config) {
  config.baseURL += store.state.user.customer;
  config.headers["Authorization"] =
    "Token " + localStorage.getItem("user-token");

  return config;
});

export default API;
